// Customer Theme
module.exports = {
    theme: {
        colors: {
            primary: {
                900: '#8e602a',
                800: '#a67031',
                700: '#be8038',
                600: '#d6903f',
                500: '#eea047',
                400: '#efa959',
                300: '#f1b36b',
                200: '#f3bc7e',
                100: '#f4c690',
                50: '#f8d9b5',
            },

            secondary: {
                900: '#151213',
                800: '#181516',
                700: '#1c1819',
                600: '#1f1b1c',
                500: '#231e20',
                400: '#383436',
                300: '#4e4a4c',
                200: '#656162',
                100: '#7b7879',
                50: '#a7a5a5',
            },
        },
    },
}
